import { ComparisonFilterInput, NestedLogicalFilterInput } from '@hello-aria/query-string/dist/stringify'
import { LogicalFilter, LogicalOperator } from '@hello-aria/query-string'
import { Repayment, RepaymentGateway, RepaymentReconciliationStatus } from '../models/repaymentModel'
import { SafeMath } from './numberUtils'

export interface ResolveRepaymentFilters {
    type: LogicalFilter['type']
    operator: LogicalOperator
    filters: (
        | ComparisonFilterInput
        | {
              type: LogicalFilter['type']
              operator: LogicalOperator
              filters: ComparisonFilterInput[]
          }
    )[]
}

export type ResolveRepaymentFiltersParams = {
    customFilters?: (ComparisonFilterInput | NestedLogicalFilterInput)[]
}

export const resolveRepaymentFilters = ({ customFilters }: ResolveRepaymentFiltersParams): ResolveRepaymentFilters => {
    const filters: (ComparisonFilterInput | NestedLogicalFilterInput)[] = customFilters ?? []

    return {
        type: 'logical',
        operator: 'and',
        filters
    }
}

export const mapRepayment = (repayment: RepaymentGateway): Repayment => {
    const totalAllocations =
        repayment.paymentReconciliations?.reduce((acc, curr) => SafeMath.add(acc, curr.allocatedAmount), 0) ?? 0

    const mapRepaymentAllocationsStatus = (): RepaymentReconciliationStatus => {
        if (totalAllocations >= repayment.amount) return 'RECONCILIATED'
        if (totalAllocations > 0 && totalAllocations < repayment.amount) return 'PARTIALLY_RECONCILIATED'

        return 'NOT_RECONCILIATED'
    }

    return {
        ...repayment,
        balance: SafeMath.subtract(repayment.amount, totalAllocations),
        allocationsStatus: mapRepaymentAllocationsStatus()
    }
}
